import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";

gsap.registerPlugin(ScrollTrigger, CustomEase);

export function initFrontAnim() {
  const isPresent = document.querySelector("#animatedPath");
  if (!isPresent) {
    return;
  }

  const animatedPath = document.querySelector("#animatedPath");
  const pathLength = animatedPath.getTotalLength();

  // Set up the initial state of the animated path
  animatedPath.style.strokeDasharray = pathLength;
  animatedPath.style.strokeDashoffset = -pathLength;

  // Define a custom easing function that speeds up in the middle
  CustomEase.create("customEase", "M0,0 C0.3,0.5 0.7,0.5 1,1");

  gsap.to(animatedPath, {
    strokeDashoffset: 0,
    ease: "customEase", // Use the custom easing function
    scrollTrigger: {
      trigger: "#animatedPath",
      start: "top top",
      end: "60% top",
      scrub: true,
    },
  });
}

export function initFrontLineAnim() {
  const isPresent = document.querySelector(".separator-line");
  if (!isPresent) {
    return;
  }

  // Define a custom easing function that speeds up in the middle
  CustomEase.create("customEase", "M0,0 C0.3,0.5 0.7,0.5 1,1");

  // Animate the vertical line height
  gsap.to(".separator-line", {
    height: "100%",
    ease: "customEase",
    scrollTrigger: {
      trigger: ".separator-line-container",
      start: "top 40%", // Start drawing when the line enters the viewport
      end: "bottom 100%", // End when the bottom of the line is near the viewport top
      scrub: true,
    },
  });
}
